module.exports = __webpack_public_path__ + "img/Fotoconcept.88a07c36.png";